import { render, staticRenderFns } from "./sch_jiuye_bzr.vue?vue&type=template&id=bcf57c46&scoped=true&"
import script from "./sch_jiuye_bzr.vue?vue&type=script&lang=js&"
export * from "./sch_jiuye_bzr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf57c46",
  null
  
)

export default component.exports